import formatNumber from "../../helpers/format.number";
import formatIcNo from "../../helpers/format.ic";

const text = (...values) => {
  const value = values.find(
    (item) => item !== undefined && item !== null && item !== "",
  );
  if (value && typeof value === "object")
    return value.name || value.label || "";
  return value ?? "";
};

function displayMoney(value, fallback = "-") {
  if (value === undefined || value === null || value === "") return fallback;

  if (
    typeof value === "string" &&
    value.trim().toUpperCase().startsWith("RM")
  ) {
    return value;
  }

  try {
    return `RM ${formatNumber(value)}`;
  } catch {
    return String(value);
  }
}

export default function agreementData(record = {}, profile = {}) {
  const source = record.source || record;
  const vehicle = source.product || source.vehicle || source;
  const properties = vehicle.properties || {};
  const identity = source.identity_details || source.seller || {};
  const address = identity.mailing_address || identity.address;
  const mailingAddress = Array.isArray(address)
    ? address
    : [
        text(address),
        text(identity.city),
        [text(identity.postcode), text(identity.state)]
          .filter(Boolean)
          .join(" "),
      ].filter(Boolean);
  const name = text(
    identity.company_name,
    [identity.legal_last_name, identity.legal_first_name]
      .filter(Boolean)
      .join(" "),
    identity.name,
  );
  const idNo = text(
    formatIcNo(identity.ic_no),
    identity.id_no,
    identity.company_register_no,
  );
  const mobileNo = text(source.contact, identity.mobile_no);
  const price = text(
    source.agreed_selling_price,
    source.selling_price,
    vehicle.price,
  );
  return {
    date: new Date().toLocaleDateString("en-GB"),
    owner: { name, idNo, mailingAddress, mobileNo },
    buyer: {
      name,
      identificationNo: idNo,
      mailingAddress,
      mobileNo,
      email: text(source.company_name, "-"),
    },
    vehicle: {
      make: text(vehicle.make, vehicle.brand, properties.make),
      model: text(vehicle.model, vehicle.car_model, properties.model),
      registrationNo: text(
        vehicle.car_plate,
        source.car_plate,
        properties.car_plate,
      ),
      engineCapacity: text(vehicle.engine_capacity_cc),
      engineNo: text(vehicle.engine_no),
      yearOfManufacture: text(vehicle.register_year, vehicle.year),
      chassisNo: text(vehicle.chassis_no),
      mileage: text(source.odometer, vehicle.mileage, properties.mileage),
      purchasePrice: displayMoney(price),
    },
    agreedSellingPrice: displayMoney(price),
    charges: {
      roadTax: text(source.road_tax),
      insurance: text(source.insurance),
      workshopAccessories: text(source.workshop_accessories),
    },
    salesAgent: text(source.sales_agent),
  };
}
